<template>
  <div :class="$style.root">
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
    },
    limit: {
      type: Boolean,
    },
  },
  computed: {
    label () {
      let label
      if (this.levelLabel) {
        label = this.levelLabel
      }
      if (this.limitLabel) {
        label = `${this.limitLabel} (${label})`
      }
      return label
    },
    levelLabel () {
      if (this.level === '1') {
        return '第一級'
      }
      if (this.level === '2') {
        return '第二級'
      }
    },
    limitLabel () {
      if (this.limit === true) {
        return '有時間限制'
      }
      if (this.limit === false) {
        return '無時間限制'
      }
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply px-4;
  @apply py-2;
  @apply font-bold;
  background-color: #00000040;
  color: white;
}
</style>
